module.exports = __webpack_public_path__ + "media/1893-1923.0651ca7f.mp4";